/* import __COLOCATED_TEMPLATE__ from './destinations-card.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class DestinationsCardComponent extends Component
{
	@service store;
	@service uploaderAjax;
	@service errorManager;
	@service confirmation;
	
	@tracked isAddingNew = false;
	@tracked newDestinationName = "";
	@tracked newDestinationHost = "";
	@tracked newPEM = null;
	@tracked newSecretKey = null;
	@tracked newAccessKey = null;

	@action
	toggleAddingNew() {
		this.isAddingNew = !this.isAddingNew;
	}

	@action
	async changeEnabled(destination, event)
	{
		try
		{
			destination.set('enabled', event.target.checked);
			await destination.save();
		}
		catch (error)
		{
			destination.rollbackAttributes();
			// Error is displayed by the adapter
		}
	}
	
	@action
	async saveNew(browserEvent)
	{
		browserEvent.preventDefault();

		if (this.newPEM == "")
		{
			this.newPEM = null;
		}
		if (this.newSecretKey == "")
		{
			this.newSecretKey = null;
		}
		if (this.newAccessKey == "")
		{
			this.newAccessKey = null;
		}

		const newDestination = this.store.createRecord('destination',
		{
			name: this.newDestinationName,
			host: this.newDestinationHost,
			PEM: this.newPEM,
			accessKeyId: this.newAccessKey,
			secretAccessKey: this.newSecretKey
		});

		try
		{
			await newDestination.save();
			await this.store.findRecord('destination', newDestination.id);
		}
		catch (error)
		{
			newDestination.rollbackAttributes();
			// Error is displayed by the adapter
			return;
		}

		this.resetNew();
	}
	
	@action cancelNew()
	{
		this.resetNew();
	}
	
	resetNew()
	{
		this.newDestinationName = "";
		this.newDestinationHost = "";
		this.newPEM = null;
		this.newSecretKey = null;
		this.newAccessKey = null;
		this.isAddingNew = false;
	}
	
	@action
	async deleteDestination(destination)
	{
		const confirmed = await this.confirmation.confirm({
			title: 'Delete Destination',
			message: `Are you sure you want to delete the destination "${destination.name}"?`,
			confirmLabel: 'Delete',
			confirmStyle: 'danger'
		});
		if (!confirmed)
		{
			return;
		}

		try
		{
			destination.deleteRecord();
			await destination.save();
		}
		catch (error)
		{
			destination.rollbackAttributes();
			// Error is displayed by the adapter
		}
	}
}